  import {
    Component,
    OnInit,
    OnDestroy,
    HostListener,
    ElementRef
  } from '@angular/core';

  import { Router } from '@angular/router';
  import { Subscription } from 'rxjs';

  import { OrderNotificationService } from '../../@core/services/order-notification.service';
  import { DataService } from '../data.service'; // ⚠️ adjust this path to wherever data.service.ts actually lives relative to this component
  @Component({
    selector: 'ngx-order-header-dropdown',
    templateUrl: './order-header-dropdown.component.html',
    styleUrls: ['./order-header-dropdown.component.scss']
  })
  export class OrderHeaderDropdownComponent implements OnInit, OnDestroy {

    isOpen = false;

    orders: any[] = [];

    unreadCount = 0;

    private subs = new Subscription();


    constructor(
      private orderService: OrderNotificationService,
      private router: Router,
      private elRef: ElementRef,
      private readonly dataService: DataService
    ) {}


    ngOnInit() {

      this.subs.add(
        this.orderService.orders$.subscribe((orders) => {

          console.log('📦 Orders updated in dropdown:', orders);

          this.orders = orders;

        })
      );


      this.subs.add(
        this.orderService.unreadCount$.subscribe((count) => {

          this.unreadCount = count;

        })
      );

    }


    ngOnDestroy() {

      this.subs.unsubscribe();

    }


    toggleDropdown(event: MouseEvent) {

      event.stopPropagation();

      this.isOpen = !this.isOpen;

    }


    @HostListener('document:click', ['$event'])
    onOutsideClick(event: MouseEvent) {

      if (!this.elRef.nativeElement.contains(event.target)) {

        this.isOpen = false;

      }

    }


  openOrder(order: any, event: MouseEvent) {

      event.stopPropagation();

      this.orderService.markOrderSeen(order._id);

      this.isOpen = false;

      /*
      * Navigate to the same order-details route the
      * Grocery Orders table uses (see onEdit() in
      * view-order.component.ts), so it opens the
      * specific order that was clicked.
      */
      this.router.navigate(
        ['/admin/grocery-orders/order-details', { id: order.orderId }]
      );

      this.dataService.setNewRowInfo(order);

    }


    getTimeLabel(dateStr: string): string {

      if (!dateStr) {
        return '';
      }


      const d = new Date(dateStr);

      const diffMin = Math.floor(
        (Date.now() - d.getTime()) / 60000
      );


      if (diffMin < 1) {
        return 'just now';
      }


      if (diffMin < 60) {
        return `${diffMin}m ago`;
      }


      if (diffMin < 1440) {
        return `${Math.floor(diffMin / 60)}h ago`;
      }


      return d.toLocaleDateString(
        'en-GB',
        {
          day: '2-digit',
          month: 'short'
        }
      );

    }

  }